<template>
  <v-dialog :value="show" persistent max-width="500px">
    <v-card>
      <v-card-text>
        <v-container>
          <h1>{{ $t('element.editElement') }}</h1>
        </v-container>
      </v-card-text>

      <v-card-text>
        <v-text-field
          v-model="element.name"
          outlined
          :label="$t('global.inputNaturalLanguage')"
          counter="100"
          maxLength="100"
          required
        />
        <v-text-field
          v-model="element.prolog"
          outlined
          :label="$t('global.inputLogicalLanguage')"
          counter="1000"
          maxLength="1000"
          required
        />

        <choose-element-type
          @chooseElementType="chooseElementType"
          :possible-values="['fact', 'belief', 'hypothesis']"
          :label="$t('element.defineElementType')"
          :value="element.type"
        />

        <template v-if="element.type === 'fact' || element.type === 'hypothesis'">
          <v-alert
            v-show="warnBeliefToFact"
            dense
            outlined
            text
            type="warning"
          >{{ $t('element.youHaveToEditScenariosToRemoveTheOpposite') }}</v-alert>
          <h3 class="pa-3">{{ $t('element.factEdition') }}</h3>
          <v-textarea
            v-model="element.background"
            :label="$t(`global.inputNaturalLanguage`)"
            counter="2500"
            maxLength="2500"
            outlined
          />
          <v-textarea
            v-model="element.prologBackground"
            :label="$t('global.inputLogicalLanguage')"
            counter="2500"
            maxLength="2500"
            outlined
          />

        </template>

        <template v-if="element.type === 'belief'">
          <h3 class="pa-3">{{ $t('element.beliefEdition') }}</h3>

          <v-card-actions>
            <div class="ma-auto">
              <v-btn
                class="mx-1"
                outlinded
                :color="argueBeliefState ? 'primary': ''"
                @click="argueBeliefState = true"
              >
                {{ $t('global.yes') }}
              </v-btn>
              <v-btn
                class="mx-1"
                :outlinded="!argueBeliefState"
                :color="!argueBeliefState ? 'primary': ''"
                @click="argueBeliefState = false"
              >
                {{ $t('global.no') }}
              </v-btn>
            </div>
          </v-card-actions>
        </template>
      </v-card-text>

      <v-card-actions>
        <div class="ma-auto">
          <v-btn
            color="primary"
            tile
            @click="loading=true;confirmEdit();"
            class="mx-1"
            :loading="loading"
          >
            {{ $t('global.validate') }}
          </v-btn>
          <v-btn
            color="ternary"
            dark
            tile
            @click="cancel"
            class="mx-1"
          >
            {{ $t('global.cancel') }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ChooseElementType from '@/components/scenariiList/ChooseElementType';
import elementService from '@/services/elements.js';

export default {
  name: 'EditElementDialog',

  components: { ChooseElementType },

  data () {
    return {
      argueBeliefState: false,
      decisionPolicyUpdated: false,
      loading: false,
      warnBeliefToFact: false,
    };
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    element: {
      type: Object,
      required: true,
    },
  },

  computed: {
    show: {
        get () {
            return this.open;
        },
        set (value) {
            this.$emit('update:open', value);
        }
    },
  },

  methods: {
    cancel () {
      this.$emit('cancel-element-edition');
    },

    chooseElementType (elementType) {
      if(this.element.type === 'belief') {
        this.warnBeliefToFact = true;
      }
      else {
        this.warnBeliefToFact = false;
      }

      this.element.type = elementType;
      if(elementType === 'hypothesis' && !this.element.prologBackground) {
        this.element.prologBackground = 'abducible('+this.element.prolog+',[]).\nabducible(neg('+this.element.prolog+'),[]).';
      }
      else {
        this.element.prologBackground = '';
      }
      this.decisionPolicyUpdated = true;
    },

    confirmEdit () {
      this.loading = true;
      let projectId = this.$route.params.id;
      elementService.updateElement(projectId, this.element).then( res => {
        this.$emit('element-updated', Object.assign({ decisionPolicyUpdated: this.decisionPolicyUpdated || this.argueBeliefState }, res.data));
        if (this.argueBeliefState) {
          this.$router.push({name: 'addScenarii', params: { id: projectId, beliefId: this.element.id } });
        }
      })
      .catch(err => {
        this.$emit('raison-event', { type: 'error', messages: [err] });
      })
      .finally(() => {
        this.loading = false;
        this.show = false;
      });
    },
  },

};
</script>